/* Verasah — localStorage Wishlist */
(function () {
  'use strict';

  var STORAGE_KEY = 'verasah-wishlist';

  /* ─── Storage helpers ─────────────────────────────────────────────── */
  var Wishlist = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch (e) { return []; }
    },
    set: function (items) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }
      catch (e) {}
    },
    has: function (id) {
      return this.get().some(function (i) { return i.id === id; });
    },
    add: function (product) {
      var items = this.get();
      if (!items.some(function (i) { return i.id === product.id; })) {
        items.unshift(product); // newest first
        this.set(items);
      }
    },
    remove: function (id) {
      this.set(this.get().filter(function (i) { return i.id !== id; }));
    },
    toggle: function (product) {
      if (this.has(product.id)) { this.remove(product.id); return false; }
      else { this.add(product); return true; }
    },
    count: function () { return this.get().length; }
  };

  /* ─── Drawer ──────────────────────────────────────────────────────── */
  var drawer  = document.getElementById('wishlist-drawer');
  var overlay = drawer && drawer.querySelector('[data-wishlist-close]');
  var listEl  = drawer && drawer.querySelector('[data-wishlist-items]');
  var countEls = document.querySelectorAll('[data-wishlist-count]');

  function openDrawer()  { if (drawer) drawer.classList.add('is-open'); }
  function closeDrawer() { if (drawer) drawer.classList.remove('is-open'); }

  function updateCount() {
    var n = Wishlist.count();
    countEls.forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function formatMoney(cents) {
    return window.vMoney(cents);
  }

  function renderDrawer() {
    if (!listEl) return;
    var items = Wishlist.get();

    if (items.length === 0) {
      listEl.innerHTML =
        '<p class="wishlist-drawer__empty">Your wishlist is empty.</p>';
      return;
    }

    listEl.innerHTML = items.map(function (item) {
      return [
        '<div class="wishlist-item" data-wishlist-item="' + item.id + '">',
          item.image
            ? '<a href="' + item.url + '" class="wishlist-item__image-link">' +
                '<img class="wishlist-item__image" src="' + item.image + '" alt="' + item.title + '" width="80" height="80">' +
              '</a>'
            : '<div class="wishlist-item__image wishlist-item__image--placeholder"></div>',
          '<div class="wishlist-item__info">',
            '<a href="' + item.url + '" class="wishlist-item__title">' + item.title + '</a>',
            '<p class="wishlist-item__price">' + formatMoney(item.price) + '</p>',
            '<div class="wishlist-item__actions">',
              item.variantId
                ? '<button class="btn btn--primary wishlist-item__add" ' +
                    'data-wishlist-add-to-cart="' + item.variantId + '" ' +
                    'data-product-id="' + item.id + '">Add to cart</button>'
                : '',
              '<button class="wishlist-item__remove" data-wishlist-remove="' + item.id + '" aria-label="Remove">',
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 6 6 18M6 6l12 12"/></svg>',
              '</button>',
            '</div>',
          '</div>',
        '</div>'
      ].join('');
    }).join('');
  }

  /* ─── Button state ────────────────────────────────────────────────── */
  function syncButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var id = parseInt(btn.dataset.productId, 10);
      var active = Wishlist.has(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  /* ─── Event listeners ─────────────────────────────────────────────── */
  // Open drawer
  document.querySelectorAll('[data-wishlist-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      renderDrawer();
      openDrawer();
    });
  });

  // Close drawer
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist-close]')) closeDrawer();
  });

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Toggle wishlist button on product cards / PDP
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    toggleFromButton(btn);
  });

  // Phones: handle the tap directly on touchend. Otherwise iOS Safari spends
  // the first tap on the card's hover effects (second image, gallery arrows)
  // and only registers the save on a second tap. preventDefault stops the
  // browser's follow-up click, so the click listener above doesn't toggle
  // the same tap a second time. A finger that moved (scrolling) is ignored.
  var touchStart = null;
  document.addEventListener('touchstart', function (e) {
    var btn = e.target.closest('[data-wishlist-btn]');
    touchStart = btn ? { btn: btn, x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!touchStart) return;
    var start = touchStart;
    touchStart = null;
    var t = e.changedTouches[0];
    if (Math.abs(t.clientX - start.x) > 10 || Math.abs(t.clientY - start.y) > 10) return;
    if (e.target.closest('[data-wishlist-btn]') !== start.btn) return;
    e.preventDefault();
    toggleFromButton(start.btn);
  }, { passive: false });

  // Tells Klaviyo about the save so the wishlist-reminder flow can email
  // the shopper. Sends the WHOLE current wishlist, not just this piece, so a
  // single email can show everything they've saved. Klaviyo only records it
  // for shoppers it can identify (clicked a Verasah email, signed up, started
  // checkout); for anonymous visitors this is silently dropped by Klaviyo.
  function absoluteUrl(u) {
    if (!u) return '';
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (u.charAt(0) === '/') return window.location.origin + u;
    return u;
  }

  function toKlaviyoItem(item) {
    return {
      ProductID: String(item.id),
      ProductName: item.title,
      URL: absoluteUrl(item.url),
      ImageURL: absoluteUrl(item.image),
      Price: item.price / 100
    };
  }

  function trackKlaviyoWishlist(product) {
    try {
      var items = Wishlist.get().slice(0, 12).map(toKlaviyoItem);
      var props = toKlaviyoItem(product);
      props.$value = props.Price;
      props.Items = items;
      props.ItemCount = Wishlist.count();
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track('Added to Wishlist', props);
      } else if (window._learnq) {
        window._learnq.push(['track', 'Added to Wishlist', props]);
      }
    } catch (e) { /* never let tracking break the heart button */ }
  }

  /* ─── Email prompt (once, after first save, unknown shoppers only) ── */
  // Without an email Klaviyo can't send the wishlist reminder, so after the
  // first heart we offer to email the wishlist. Entering an email subscribes
  // the shopper to the Email List (marketing consent -- the wording says so),
  // and records this save against their profile.
  var KLAVIYO_COMPANY = 'Yfb8hq';
  var EMAIL_LIST_ID = 'UCim7V';
  var PROMPT_KEY = 'verasah-wishlist-prompt'; // 'dismissed' | 'subscribed'

  function promptDone() {
    try { return !!localStorage.getItem(PROMPT_KEY); } catch (e) { return true; }
  }
  function markPrompt(state) {
    try { localStorage.setItem(PROMPT_KEY, state); } catch (e) {}
  }

  function klaviyoKnowsShopper() {
    try {
      if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
        return Promise.resolve(window.klaviyo.isIdentified()).catch(function () { return false; });
      }
    } catch (e) {}
    return Promise.resolve(false);
  }

  function klaviyoPost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + KLAVIYO_COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('Klaviyo ' + path + ' ' + r.status);
    });
  }

  function subscribeAndRecord(email, product) {
    var profile = { data: { type: 'profile', attributes: { email: email } } };
    var props = toKlaviyoItem(product);
    props.$value = props.Price;
    props.Items = Wishlist.get().slice(0, 12).map(toKlaviyoItem);
    props.ItemCount = Wishlist.count();
    return klaviyoPost('subscriptions', {
      data: {
        type: 'subscription',
        attributes: { profile: profile, custom_source: 'Wishlist prompt' },
        relationships: { list: { data: { type: 'list', id: EMAIL_LIST_ID } } }
      }
    }).then(function () {
      return klaviyoPost('events', {
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Added to Wishlist' } } },
            profile: profile,
            properties: props
          }
        }
      });
    }).then(function () {
      // Link this browser to the profile so later saves are tracked directly.
      try { if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email }); } catch (e) {}
    });
  }

  function closePrompt(el) {
    el.classList.remove('is-open');
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 250);
  }

  function showEmailPrompt(product) {
    if (document.querySelector('.wishlist-prompt')) return;
    var el = document.createElement('div');
    el.className = 'wishlist-prompt';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', 'Email your wishlist');
    el.innerHTML = [
      '<button type="button" class="wishlist-prompt__close" aria-label="Close" data-wl-prompt-dismiss>',
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 6 6 18M6 6l12 12"/></svg>',
      '</button>',
      '<p class="wishlist-prompt__title">Saved to your wishlist</p>',
      '<p class="wishlist-prompt__text">Want us to email you your wishlist?</p>',
      '<form class="wishlist-prompt__form" novalidate>',
        '<input type="email" name="email" class="wishlist-prompt__input" placeholder="Your email" autocomplete="email" aria-label="Your email" required>',
        '<p class="wishlist-prompt__error" hidden></p>',
        '<div class="wishlist-prompt__actions">',
          '<button type="submit" class="btn btn--primary wishlist-prompt__save">Email my wishlist</button>',
          '<button type="button" class="wishlist-prompt__skip" data-wl-prompt-dismiss>No thanks</button>',
        '</div>',
        '<p class="wishlist-prompt__legal">By saving, you agree to receive emails from Verasah, including your wishlist and occasional news. Unsubscribe anytime. ',
          '<a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy policy</a></p>',
      '</form>'
    ].join('');
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-open'); });

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-wl-prompt-dismiss]')) {
        markPrompt('dismissed');
        closePrompt(el);
      }
    });

    var form = el.querySelector('form');
    var input = el.querySelector('input');
    var error = el.querySelector('.wishlist-prompt__error');
    var save = el.querySelector('.wishlist-prompt__save');
    input.addEventListener('input', function () { error.hidden = true; });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        error.textContent = 'Please enter a valid email address.';
        error.hidden = false;
        return;
      }
      save.disabled = true;
      save.textContent = 'Saving…';
      subscribeAndRecord(email, product).then(function () {
        markPrompt('subscribed');
        form.innerHTML = '<p class="wishlist-prompt__text">Thank you — we’ll email you your wishlist.</p>';
        setTimeout(function () { closePrompt(el); }, 2500);
      }).catch(function () {
        save.disabled = false;
        save.textContent = 'Email my wishlist';
        error.textContent = 'Something went wrong. Please try again.';
        error.hidden = false;
      });
    });
  }

  function maybePromptForEmail(product) {
    if (promptDone()) return;
    klaviyoKnowsShopper().then(function (known) {
      if (known) { markPrompt('known'); return; }
      showEmailPrompt(product);
    });
  }

  function toggleFromButton(btn) {
    var product = {
      id:        parseInt(btn.dataset.productId, 10),
      title:     btn.dataset.productTitle,
      price:     parseInt(btn.dataset.productPrice, 10),
      image:     btn.dataset.productImage || '',
      url:       btn.dataset.productUrl,
      variantId: btn.dataset.productVariant ? parseInt(btn.dataset.productVariant, 10) : null
    };

    var added = Wishlist.toggle(product);

    // GA4 analytics — fire event when product is saved to wishlist
    if (added && typeof gtag === 'function') {
      gtag('event', 'add_to_wishlist', {
        currency: 'AUD',
        value: product.price / 100,
        items: [{
          item_id: String(product.id),
          item_name: product.title,
          price: product.price / 100,
          currency: 'AUD'
        }]
      });
    }

    if (added) {
      trackKlaviyoWishlist(product);
      maybePromptForEmail(product);
    }

    // Animate
    btn.classList.toggle('is-active', added);
    btn.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Add to wishlist');

    // Pulse animation
    btn.classList.add('wishlist-btn--pulse');
    setTimeout(function () { btn.classList.remove('wishlist-btn--pulse'); }, 400);

    updateCount();
  }

  // Remove from drawer
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-remove]');
    if (!btn) return;
    var id = parseInt(btn.dataset.wishlistRemove, 10);
    Wishlist.remove(id);
    syncButtons();
    updateCount();
    renderDrawer();
  });

  // Add to cart from drawer
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-add-to-cart]');
    if (!btn) return;
    var variantId = parseInt(btn.dataset.wishlistAddToCart, 10);
    var productId = parseInt(btn.dataset.productId, 10);

    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.textContent = 'Added!';
      // Update cart count
      return fetch('/cart.js');
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var countEl = document.querySelector('[data-cart-count]');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.hidden = false;
      }
      // Remove from wishlist after adding to cart
      setTimeout(function () {
        Wishlist.remove(productId);
        syncButtons();
        updateCount();
        renderDrawer();
      }, 800);
    })
    .catch(function () {
      btn.textContent = 'Add to cart';
      btn.disabled = false;
    });
  });

  /* ─── Init ────────────────────────────────────────────────────────── */
  updateCount();
  syncButtons();

})();
